import store from '@/store';

/**
 * 表格公用参数
 * 表格默认请求数据函数为【getPageList】
 * 不是【getPageList】则使用callBack回调
 * @returns {{tableLoading: boolean, tablePagination: {total: number, current: number, onChange: TableRelevant.tablePagination.onChange, pageSize: number, showLessItems: boolean, showSizeChanger: boolean}}}
 * @constructor
 */
export const tableRelevant = function (callBack) {
    const TableRelevant = {
        search: {},
        tableLoading: false,
        key: Date.now(),
        tableDataSource: [], //table数据
        selectedRowKeys: [], //table数据
        selectedRows: [], //table数据
        locale: {
            emptyText: '暂无数据',
        },
        tablePagination: {
            showLessItems: true,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) => `第 ${range[0]} 至 ${range[1]} 条，总计 ${total} 条`,
            pageSizeOptions: ['10', '20', '50', '100', '500', '1000'],
            total: 0,
            pageSize: 10,
            current: 1,
            onChange: (current, pageSize) => {
                TableRelevant.tablePagination.current = current;
                TableRelevant.tablePagination.pageSize = pageSize;
                if (callBack) {
                    callBack();
                    return;
                }
                this && this.getPageList && this.getPageList();
            },
            onShowSizeChange: (current, pageSize) => {
                localStorage.setItem('page_size', pageSize);
                TableRelevant.tablePagination.current = current;
                TableRelevant.tablePagination.pageSize = pageSize;
                if (callBack) {
                    callBack();
                    return;
                }
                this && this.getPageList && this.getPageList();
            },
        },
    };
    return TableRelevant;
};

/**
 * form表单校验手机号
 * @param rule
 * @param value
 * @param callback
 * @returns {*}
 * @constructor
 */
export const CheckPhone = (rule, value, callback) => {
    if (!rule.required && !value) {
        return callback();
    }
    if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error('请输入正确的手机号码'));
    }
    return callback();
};

/**
 * 校验字符串是否为网址
 * @param str
 * @returns {boolean}
 * @constructor
 */
export const IsWebsite = (str) => {
    return /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/.test(str);
};

/**
 * 格式化日期
 * @param date 时间戳
 * @param format YYYY-MM-DD hh:mm:ss
 * @returns {boolean}
 * @constructor
 */
export const FormatDate = (date, format) => {
    const DateTime = new Date(date);
    let year = DateTime.getFullYear();
    let month = DateTime.getMonth() + 1 < 10 ? '0' + (DateTime.getMonth() + 1) : DateTime.getMonth() + 1;
    let day = DateTime.getDate() < 10 ? '0' + DateTime.getDate() : DateTime.getDate();
    let hour = DateTime.getHours() < 10 ? '0' + DateTime.getHours() : DateTime.getHours();
    let minute = DateTime.getMinutes() < 10 ? '0' + DateTime.getMinutes() : DateTime.getMinutes();
    let second = DateTime.getSeconds() < 10 ? '0' + DateTime.getSeconds() : DateTime.getSeconds();

    if (format === 'YYYYMMDDhhmmss') {
        return '' + year + month + day + hour + minute + second;
    }

    return format.replace(/\b[A-Za-z]+\b/g, function (word) {
        switch (word) {
            case 'YYYY':
                return year;
            case 'MM':
                return month;
            case 'DD':
                return day;
            case 'hh':
                return hour;
            case 'mm':
                return minute;
            case 'ss':
                return second;
            default:
                return '';
        }
    });
};

/**
 * 复杂数组去重
 * @param arr 源数组
 * @param type 指定数组某一项去重
 * @returns {Array}
 * @constructor
 */
export const ArrayUnique = (arr, type) => {
    for (let i = 0, len = arr.length; i < len; i++) {
        for (let j = i + 1, len = arr.length; j < len; j++) {
            let iType = type ? arr[i][type] : arr[i];
            let jType = type ? arr[j][type] : arr[j];
            if (iType === jType) {
                arr.splice(j, 1);
                j--;
                len--;
            }
        }
    }
    return arr;
};

export const ArrayUnique2 = (arr) => {
    let len = arr.length;
    for (let i = 0; i < len; i++) {
        for (let j = i + 1; j < len; j++) {
            if (arr[i] === arr[j]) {
                arr.splice(j, 1);
                len--; // 减少循环次数提高性能
                j--; // 保证j的值自加后不变
            }
        }
    }
    return arr;
};

/**
 * 数组去重
 * @param module string 模块（Course）
 * @param auth string 权限名称（Content.Course.Classify）
 * @returns {Boolean}
 * @constructor
 */
export const ModuleAuth = (module, auth) => {
    const permissions = store.getters['account/permissions'].filter((f) => f.id === module)[0];
    if (permissions && permissions.operation) {
        return permissions.operation.includes(auth);
    }
    return false;
};

/**
 * 秒格式化时分秒
 * @param seconds
 * @returns {string}
 * @constructor
 */
export function SecondsToTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    const fullZero = n => {
        return n < 10 ? "0" + n : n;
    };

    return fullZero(hours) + ":" + fullZero(minutes) + ":" + fullZero(remainingSeconds);
}
